//----------------CORE-----------------//
import React, { useRef, useState } from "react";
//--------------MUI-------------//
import ClickAwayListener from "@mui/material/ClickAwayListener";
import SearchIcon from "@mui/icons-material/Search";
import Zoom from "@mui/material/Zoom";
import CloseIcon from "@mui/icons-material/Close";
import Tooltip from "@mui/material/Tooltip";
import Fab from "@mui/material/Fab";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Badge from "@mui/material/Badge";
import InputBase from "@mui/material/InputBase";
//-----------EXTERNAL--------//
import Dragable from "components/Dragable";
import "./catalogue.css";

// D30 (2) (roles prod promotion, Stage 3, 2026-09-25): the bottom-right solution search,
// shared by the main solutions page and Solution Management. The page owns the text and does
// the matching (name, description, tag names: utils/solutionTags). The box closes on a click
// elsewhere through MUI's ClickAwayListener; the main page used to add a new document click
// listener on every render and click for this (a leak), which is not carried over.
export default function SolutionSearch({ value, onChange, name }) {
  const [open, setOpen] = useState(false);
  const inputRef = useRef(null);
  return (
    <ClickAwayListener onClickAway={() => setOpen(false)}>
      <div>
        <span
          onClick={() => {
            if (!open && inputRef.current) inputRef.current.focus();
            setOpen(!open);
          }}
        >
          <Dragable bottom={"30px"} right={"30px"} name={name}>
            <Tooltip
              title={!open ? "Search Solutions" : "Close search"}
              TransitionComponent={Zoom}
              placement="bottom"
              arrow
            >
              <Fab
                style={{ boxShadow: "none" }}
                color="secondary"
                aria-label="search solutions"
                className="btn-search"
              >
                {open ? (
                  <ArrowForwardIosIcon />
                ) : value ? (
                  <Badge color="primary" variant="dot">
                    <SearchIcon />
                  </Badge>
                ) : (
                  <SearchIcon />
                )}
              </Fab>
            </Tooltip>
          </Dragable>
        </span>
        <Box sx={{ width: 500, maxWidth: "100%", position: "fixed" }}>
          <InputBase
            placeholder="Search Solutions"
            onChange={(e) => onChange(e.target.value)}
            value={value}
            id="search-sol"
            inputRef={inputRef}
            color="secondary"
            className={!open ? "hide-search" : "show-search"}
          />
          <IconButton
            onClick={() => {
              onChange("");
              setOpen(false);
            }}
            className={value && open ? "show-icon" : "hide-icon"}
            sx={{ p: "10px" }}
            aria-label="clear search"
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </div>
    </ClickAwayListener>
  );
}
